import React from "react";
import { useRouter } from "next/router";
import { getConsentSnapshot } from "~/features/app/scripts/iubenda/controller";
import { useConsentSnapshot } from "~/features/app/scripts/iubenda/hooks";
import { shouldClearStoredAttribution } from "./utils";
export function saveParamsToStorage(paramsToPersist: string[], storageKey: string, params: URLSearchParams) {
  if (typeof window === "undefined" || !getConsentSnapshot().preferences.marketing) return;
  const storedParams: Record<string, string> = {};
  for (const [key, value] of params.entries()) {
    if (paramsToPersist.includes(key)) {
      storedParams[key] = value;
    }
  }
  if (Object.keys(storedParams).length > 0) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(storedParams));
    } catch {
      // Attribution is optional; unavailable browser storage must not break a page.
    }
  }
}

/*
 * Persists url parameters to local storage based on `paramsToPersist`
 */
export function useParamsPersistor(paramsToPersist: string[], storageKey: string) {
  const router = useRouter();
  const snapshot = useConsentSnapshot();
  const urlParams = React.useMemo(() => new URLSearchParams(router.asPath.split("?")[1] || ""), [router.asPath]);
  React.useEffect(() => {
    if (!snapshot.preferences.marketing) {
      if (shouldClearStoredAttribution(snapshot)) {
        try {
          window.localStorage.removeItem(storageKey);
        } catch {
          // Browser privacy settings can make localStorage unavailable.
        }
      }
      return;
    }
    saveParamsToStorage(paramsToPersist, storageKey, urlParams);
  }, [paramsToPersist, storageKey, urlParams, snapshot]);
}